import React from 'react';
import { Route } from 'react-router-dom';

function PublicRoute(props) {
  return <Route {...props} />;
}

export default PublicRoute;
